export function kv(k, v) {
  const result = {};
  result[k] = v;
  return result;
}
